module.exports = __webpack_public_path__ + "media/images/icons/icon-scissors-d57ad265829a0ee5196d2cff8cb1ea16.svg";